export enum Justificatif {
    EMAIL = 'email',
    BON_COMMANDE = 'bon-commande',
    COURIER = 'courier',
    CNI = 'cni',
    DOCUMENT = 'document',
    AUTRE = 'autre',
}
